import { render, staticRenderFns } from "./VAvatarIntro.vue?vue&type=template&id=ba96bf90"
import script from "./VAvatarIntro.vue?vue&type=script&lang=js"
export * from "./VAvatarIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports